import { isNil, find } from 'lodash'

export default {
  isUserSignedIn: state => !isNil(state.user),

  getUsersId: state => userId =>
    find(state.users, user => userId > 0)
}
